module.exports = __webpack_public_path__ + "../resources/images/no_attachments-f684aef4fb56aa7fa0773f9a19c9afca.svg";